import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./panels.css";
import { applyDensity, applyTheme, readDensity, readTheme } from "./state/theme";

// Before the first paint: switching themes after mount flashes the old one.
applyTheme(readTheme());
applyDensity(readDensity());

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
